/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import { FC } from 'react'
import { PopularMaps as View } from 'ui-components'
import { getMapLink, getMapThumbnailLink, getWorkspaceLink } from 'utils'
import {
  GetPopularMapsResults,
  useGetPopularMaps
} from '~explore/queries/useGetPopularMaps'

const PopularMaps: FC<{ initialData: GetPopularMapsResults }> = ({
  initialData
}) => {
  const { data = [], isLoading } = useGetPopularMaps(true, initialData)

  return (
    <View
      isLoading={isLoading}
      maps={data}
      getKey={(map) => map.id}
      getHref={(map) =>
        getMapLink({
          mapId: map.id,
          mapName: map.name
        })!
      }
      getCover={getMapThumbnailLink}
      getTitle={(map) => map.name}
      getAvatarProps={(map) => {
        if (!map?.workspace) return
        return {
          image: map?.workspace.logo!,
          name: map?.workspace.name!,
          href: getWorkspaceLink({
            workspaceId: map?.workspace.id!,
            workspaceName: map?.workspace.name!
          }),
          updatedAt: map.updatedAt
        }
      }}
      getFooterProps={(map) => ({
        likes: map.likes!,
        views: map.views!
      })}
    />
  )
}

export { PopularMaps }
